export default __webpack_public_path__ + "20543fe671afa6af4a4cd2520121dcd1.js";